import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { FreeTrial } from '../../../components/free-trial'

function FreeTrialWrapper() {
  return <FreeTrial />
}

export const freeTrialWrapper = createNgReactBridgeDirective(
  'reactFreeTrial',
  [],
  FreeTrialWrapper,
  []
)
